<template>
  <ad-car v-if="car && car.ad" :ad="car" class="ad-car-block" :class="{ 'hidden': car.hidden }" />
  <router-link
      v-else-if="car && !car.ad"
      :to="getCarLink"
      class="dealer-car"
      :class="{'without-vat':car.withoutVat}"
      draggable="false"
      :is="isDel ? 'span' : 'router-link'"
  >
    <div class="company-name">{{ car.company_name }}</div>

    <div class="dealer-car-card__head" v-if="showTags">
      <div class="package-count opacity0" v-if="$device.mobile()"></div>

      <div class="package-count" :class="{ opacity0: car.co <= 1 || tag }">
        <span v-if="car.co > 1">{{ car.co }} Útfærslur</span>
      </div>
      <!--    </div>

          <div class="dealer-car-card__head" v-else>-->
      <div
          v-if="tag"
          class="package-count"
          :class="[{ 'in-stock': inStock }, { expected: !inStock }]"
      >
        <span>{{ tag }}</span>
      </div>

      <div v-if="car.extra_package_count > 0" class="package-count-additional">
        <span>{{ car.extra_package_count }}</span> Aukabúnaður
      </div>
    </div>
    <div class="favorite-disabled-car" v-if="isDel">
      <svg
          width="22"
          height="21"
          viewBox="0 0 22 21"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
      >
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M11 4.5C13.8 4.5 16 6.7 16 9.5C16 10.1 15.9 10.8 15.6 11.3L18.5 14.2C20 12.9 21.2 11.3 21.9 9.5C20.2 5.1 15.9 2 10.9 2C9.5 2 8.2 2.3 6.9 2.7L9.1 4.9C9.7 4.6 10.4 4.5 11 4.5ZM1 1.8L3.3 4.1L3.7 4.5C2 5.8 0.7 7.5 0 9.5C1.7 13.9 6 17 11 17C12.5 17 14 16.7 15.4 16.2L15.8 16.6L18.7 19.5L20 18.2L2.3 0.5L1 1.8ZM6.5 7.3L8 8.8V9.5C8 11.2 9.3 12.5 11 12.5C11.2 12.5 11.4 12.5 11.7 12.4L13.2 13.9C12.5 14.3 11.8 14.5 11 14.5C8.2 14.5 6 12.3 6 9.5C6 8.7 6.2 8 6.5 7.3ZM10.8 6.5L13.9 9.6V9.4C13.9 7.7 12.6 6.4 10.9 6.4C10.9 6.5 10.9 6.5 10.8 6.5Z"
            fill="white"
        />
      </svg>
    </div>
    <div
        class="car-card-img"
        :style="{ 'background-image': 'url(' + getThumb + ')' }"
    >
      <div class="cars-disc" v-if="car.verdtilbod == 1 && parseInt(car.op) > 0">
        {{ (parseInt(car.v) - parseInt(car.op)).format() + ".000 kr" }}
      </div>
      <button
          @click.prevent="delFavAction(car)"
          v-if="isFavLocal"
          class="favorite-btn active"
          :class="{posTop:isParking}"
      >
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 19 18"
            width="16px"
            height="16px"
        >
          <path
              fill="currentColor"
              fill-rule="nonzero"
              d="M.39043592 7.75900512l3.94220905 3.34172878-1.22605159 5.0247121c-.24084071.9372476.79335762 1.7065382 1.63433718 1.1779176l4.39948209-2.7171816 4.39931135 2.7166695c.8175954.5043829 1.8509402-.2403286 1.6345079-1.1780882l-1.2262223-5.0242001 3.9427211-3.34189946c.7447116-.6248886.3603223-1.8509402-.6250592-1.9231412l-5.1687728-.38490135L10.1498612.66709121c-.36049294-.88945495-1.63467854-.88945495-2.01957988 0L6.1832438 5.45079188l-5.16860202.38490134c-.98486951.09660939-1.36977085 1.29842329-.62420586 1.9233119z"
          />
        </svg>
      </button>

      <button
          v-else
          class="favorite-btn default"
          @click.prevent="addFavAction(car)"
          :class="{posTop: isParking || hasDiscount}"
      >
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 19 18"
            width="16px"
            height="16px"
        >
          <path
              fill="currentColor"
              fill-rule="nonzero"
              d="M.39043592 7.75900512l3.94220905 3.34172878-1.22605159 5.0247121c-.24084071.9372476.79335762 1.7065382 1.63433718 1.1779176l4.39948209-2.7171816 4.39931135 2.7166695c.8175954.5043829 1.8509402-.2403286 1.6345079-1.1780882l-1.2262223-5.0242001 3.9427211-3.34189946c.7447116-.6248886.3603223-1.8509402-.6250592-1.9231412l-5.1687728-.38490135L10.1498612.66709121c-.36049294-.88945495-1.63467854-.88945495-2.01957988 0L6.1832438 5.45079188l-5.16860202.38490134c-.98486951.09660939-1.36977085 1.29842329-.62420586 1.9233119z"
          />
        </svg>
      </button>

      <div
          v-if="isParking"
          class="car-parking-btn"
      >
        <img src="https://bilaskra.is/i/parking.png"/>
      </div>


      <div
          v-if="hasDiscount || hasSpecialOffer"
          class="dealer-car-card__discount"
      >
        <div class="main-basic-info-price__item-discount">
          <div class="primary-block">
            <span v-if="!priceDiscount" class="current-value">
              Tilboð
            </span>
            <span v-else class="current-value">
              <IconPriceDown color="#fff"/>
              {{ priceDiscount }}
              <span class="price-currency">kr.</span>
            </span>
          </div>
        </div>
      </div>
    </div>
    <h2 class="car-card-title">
      <b>{{ car.brand }}</b>
      {{ car.model_class }} {{ car.model_name }}
    </h2>
    <div class="car-card-details">
      <span v-html="carDesc"> </span>
    </div>
    <div
        v-if="car.price_hide == 0"
        :class="['car-card-price', { discount: car.discount > 0 }]"
    >
      <span>
        <b>{{
            price
                ? price
                : car.price_other_mod
                    ? car.price_other_mod.format()
                    : ""
          }}</b>
        {{ car.price > 0 ? " kr." : "" }}
      </span>
      <span
          style="text-decoration: line-through; color: lightgrey"
          v-if="hasDiscount"
      >
        {{ car.price ? parseInt(car.price).format() + " kr." : "Sérpöntun" }}
      </span>
      <!-- <span>Verð frá <b>{{ parseInt(car.discount).format()}}</b> kr.</span>-->
    </div>
    <div
        class="car-card-price"
        style="font-weight: bold"
        v-else-if="car.check_price == 1"
    >
      Leitið til sölumanna
    </div>
    <div class="car-card-price" style="font-weight: bold" v-else>Sérpöntun</div>
  </router-link>

</template>

<script>
import IconPriceDown from "@/components/svg/priceArrowDown";
import SaveSearchStar from "@/components/svg/saveSearchActiveIcon";
import globalNewCar from "@/helpers/globalNewCar";
import AdCar from "@/components/global/AdCar";
import {mapActions, mapState, mapMutations} from "vuex";

export default {
  components: {
    IconPriceDown,
    SaveSearchStar,
    AdCar
  },
  data: () => ({
    isFavLocal: false,
    upHere: false,
  }),
  props: ["car", "index", "scrollTop", "filter"],
  mounted() {
    this.isFavLocal = !!this.car.fav
  },
  methods: {
    ...mapActions("favorites", {
      delFav: "DEL",
      addFav: "ADD",
    }),
    ...mapActions({
      getFav: "GET_FAVORITES",
    }),
    ...mapMutations({
      setData: "SET_DATA",
    }),
    delFavAction(car) {
      this.delFav({
        sub: car.fav,
        car_id: car.id,
      }).then((res) => {
        if (!this.$store.state.profile.user) {
          this.$store.state.popup = "sign-in";
          return;
        }
        this.isFavLocal = false;
        if (this.$route.name === "Favorites") {
          this.getFav();
        }
      });
    },
    addFavAction(car) {
      //alert("addFavAction");
      this.addFav({
        sub: car.fav,
        car_id: car.id,
        is_new_car: this.$route.name === "DealersCars" ? true : false,
      }).then((res) => {
        if (!this.$store.state.profile.user) {
          this.$store.state.popup = "sign-in";
          return;
        }

        //alert("addFavAction " + JSON.stringify(res.data));
        if (res.data.status == "OK" || res.status == "OK") {
          this.isFavLocal = true;
          if (this.$route.name === "Favorites") {
            this.getFav();
          }
        }
      });
    },
  },
  computed: {
    ...mapState({
      carsByFilter: (state) => state.moduleOldCars.cars.items,
    }),
    showTags() {
      return this.$route.name === 'DealersCars'
    },
    isFav() {
      return this.car.fav && this.car.fav != 0;
    },
    isDel() {
      return this.car && this.car.del > 0 ? true : false;
    },
    carDesc() {
      return this.car.isOldCars ? this.oldCarDesc : this.newCarDesc;
    },
    getFuel() {
      let res = '';
      const car = this.car;

      if (car.fuel3 == 9000) {
        res += (car.fuel + " " + car.fuel2).replace('Rafmagn', '') + ' Hybrid';
      } else {
        res += car.fuel ? car.fuel : "";
        res += car.fuel2 ? ", " + car.fuel2 : "";
      }

      return res;
    },
    oldCarDesc() {
      let res = "";
      const car = this.car;

      res += `${car.registrationMounth ? car.registrationMounth + "/" : ''}${car.year}`;

      res += this.getFuel && res ? " · " : ''
      res += this.getFuel;

      /*res += car.fuel && res ? " · ":'' ;
      res += car.fuel ? car.fuel : "";
      res += car.fuel2 ? ", " + car.fuel2 : "";*/
      res += "<br />";

      res += car.mileage + " km. " + this.transmission;
      return res;
    },
    newCarDesc() {
      let res = "";
      const car = this.car;


      if (car.fuel_filter_id == 9000) {
        res += (car.fuel + " " + car.fuel2).replace('Rafmagn', '') + ' Hybrid';
      } else {
        res += car.fuel + (car.fuel2 ? "+" + car.fuel2 : "");
      }
      res += this.transmission && car.fuel ? " · " : "";
      res += this.transmission;
      res += car.transmision ? " · " + car.transmision : "";
      res += "<br/>";
      res +=
          car.drif +
          (car.drif && car.color ? " · " : "") +
          (car.color ? car.color : "");
      res += car.affinity ? " · Drægni " + car.affinity + " km" : "";

      return res;
    },
    hasDiscount() {
      if (this.car.discount > 0 && this.car.discount > this.car.price) {
        return null;
      }
      if (this.car.discount > 0 && this.car.price > this.car.discount) {
        return true;
      }

      return false;
    },
    hasSpecialOffer() {
      if (
          this.car.hasOwnProperty("is_special_price") &&
          this.car.is_special_price
      ) {
        return true;
      }
      return false;
    },
    hasOldCars() {
      return this.car.isOldCars;
    },
    tag() {
      return this.car.tags
          ? this.car.tags
          : this.car.status == 2
              ? "TIL Á LAGER"
              : null;
    },
    inStock() {
      return this.tag != "Frátekinn";
    },
    priceDiscount() {
      if (!this.car.discount) {
        return false;
      }
      return parseInt(this.car.price - this.car.discount).format();
    },
    getCarLink() {
      const stockCars = this.$router.resolve({
        name: "CarInStock",
        params: {id: this.car.id},
      });
      /*
      let query = window.location.search;
      if (query === "?e30=") {
        query = "";
      }*/

      let query = '';//globalNewCar.setUrlParams(this.filter);

      if (
          this.$route.name == "CarsInStock" ||
          this.$route.name == "CarInStock"
      ) {
        return `${stockCars.href}${query}`;
      }

      let newCarLink = this.$router.resolve({
        name: "DealerCar",
        params: {id: this.car.id},
      });
      if (!this.hasOldCars) {
        if (this.car.status == 2) {
          newCarLink = this.$router.resolve({
            name: "CarInStock",
            params: {id: this.car.id},
          });
        }
      }

      const car = this.$router.resolve({
        name: "Car",
        params: {id: this.car.id},
      });


      if (this.$route.name === 'k7Cars' || this.$route.name === 'k7Car') {
        const k7car = this.$router.resolve({
          name: "k7Car",
          params: {id: this.car.id},
        });

        return `${k7car.href}${query}`;
      }


      return this.hasOldCars
          ? `${car.href}${query}`
          : `${newCarLink.href}${query}`;
    },
    price() {
      return this.car.price > 0
          ? parseInt(
              this.car.discount > 0 ? this.car.discount : this.car.price
          ).format()
          : 0
    },
    transmission() {
      return this.$store.state.lib.girartegund && this.car.transmision_id
          ? this.$store.state.lib.girartegund[this.car.transmision_id].name
          : "";
    },
    isParking() {
      return this.car.parking > 0;
    },
    getThumb() {
      let imageUrl = this.$store.state.imageUrl;
      if (!this.car.thumbnail) {
        return `${imageUrl}/img/bilaumbod-front-page.png`;
      }
      if (this.car.isOldCars) {

      } else {
        if (typeof (this.car.thumbnail) == 'string') {
          if (this.car.thumbnail.indexOf(".") == -1) {
            return globalNewCar.getPicUrl(this.car.thumbnail);
          }
        }

      }
      return this.car.thumbnail;
    }
  },
  watch: {
    "car.fav": {
      immediate: true,
      handler(newVal) {
        if (!newVal || newVal == 0) {
          this.isFavLocal = false;
        } else {
          this.isFavLocal = newVal;
        }
      },
    },
  },
  // watch: {
  //     "$store.state.lib.girartegund": function () {
  //         // console.log('girartegund',this.$store.state.lib.girartegund);
  //         this.girartegund = this.$store.state.lib.girartegund;
  //     }
  // }
};
</script>
